import client from "~/apis/client"

export function fetchBookings(from, to, extra = {}) {
  return client.get("/bookings", { params: { from, to, ...extra } })
}

export function fetchBooking(id) {
  return client.get(`/bookings/${id}`)
}

export function createBooking(booking) {
  return client.post("/bookings", booking)
}

export function updateBooking(id, booking) {
  return client.patch(`/bookings/${id}`, booking)
}

export function cancelBooking(id) {
  return client.post(`/bookings/${id}/cancel`)
}

export function deleteBooking(id) {
  return client.delete(`/bookings/${id}`)
}

export function fetchMessagePreview(bookingId, kind) {
  return client.get(`/bookings/${bookingId}/message_preview`, { params: { kind } })
}

export function reinstateBooking(id) {
  return client.post(`/bookings/${id}/reinstate`)
}
